import { useContext } from 'react';
import Dashboard, { DashboardSection } from '@g17eco/molecules/dashboard';
import { TemplateDashboardHeader } from './partials/TemplateDashboardHeader';
import { TemplateSettingsHeader } from './partials/TemplateSettingsHeader';
import { TemplateContext, TemplateContextLoadedProps } from './TemplateContainer';
import { TemplateWorkgroupsView } from './partials/workgroups/TemplateWorkgroupsView';

interface TemplateWorkgroupsProps {
  renderHeader?: () => JSX.Element;
  renderBackButton?: () => JSX.Element;
  title?: string;
}

export const TemplateWorkgroups = ({ renderBackButton, renderHeader, title }: TemplateWorkgroupsProps) => {
  const templateContext = useContext(TemplateContext) as TemplateContextLoadedProps;
  const { templateData, metricGroups } = templateContext;

  return (
    <Dashboard>
      {renderBackButton ? renderBackButton() : <TemplateSettingsHeader />}
      <DashboardSection header={<TemplateDashboardHeader title={title} />}>
        {renderHeader?.()}
        <TemplateWorkgroupsView template={templateData} metricGroups={metricGroups} />
      </DashboardSection>
    </Dashboard>
  );
};
